<div *ngIf="capacity?.enabled" class="full-height layout-row gap-5">

  <div *ngIf="capacity.percentage" class="flex layout-row layout-align-start-center gap-5">
    <app-bringoz-capacity-bar [value]="capacity.percentage"
                              openDelay="300">
    </app-bringoz-capacity-bar>
    <bringoz-icon [iconName]="capacity.icon"
                  color="gray-800"
                  [ngbTooltip]="'LOAD_SETTINGS.' + capacity.type | translate"
                  openDelay="300">

    </bringoz-icon>
    <span class="br-body-2">{{capacity.percentage}}%</span>
  </div>

  <div *ngIf="!capacity.percentage" class="flex layout-row layout-align-start-center gap-5">
    <div class="unlimited-container layout-row layout-align-center-center">
      <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
    </div>
    <bringoz-icon iconName="infinite">

    </bringoz-icon>
  </div>

</div>
